import { render } from "./HolidayApplicationView.vue?vue&type=template&id=23c87309&scoped=true"
import script from "./HolidayApplicationView.vue?vue&type=script&lang=js"
export * from "./HolidayApplicationView.vue?vue&type=script&lang=js"

import "./HolidayApplicationView.vue?vue&type=style&index=0&id=23c87309&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c87309"]])

export default __exports__